import { classNames } from '~/utils/classNames';

interface LoadingBarProps {
  className?: string;
}

export function LoadingBar({ className }: LoadingBarProps) {
  return (
    <div className={classNames('absolute top-0 left-0 w-full h-[2px]', className)} role="status">
      <div className="loadingBar" />
      <span className="sr-only">Loading</span>
    </div>
  );
}
